import { Routes, Route, Navigate } from 'react-router-dom';
import NotVerifiedPage from 'pages/auth/NotVerifiedPage/NotVerifiedPage';
import VerifyAccountPage from 'pages/auth/VerifyAccountPage/VerifyAccountPage';

export default function NotVerifiedRoutes() {
  return (
    <Routes>
      <Route path="/" element={<NotVerifiedPage />} />
      <Route path="/not-verified" element={<NotVerifiedPage />} />
      <Route path="/verification/:token" element={<VerifyAccountPage />} />
      <Route path="*" element={<Navigate to="/not-verified" replace />} />
    </Routes>
  );
}